import { safeReadJson, API } from "@/lib/api";

// Stripe Subscriptions API client (frontend).
// Sessions are tied to the user's JWT; routes return Stripe checkout URLs.
const AUTH_KEY = "geovinum.auth.v1";

function authHeaders() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    const t = parsed?.token;
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
}

async function req(path, { method = "GET", body } = {}) {
  const r = await fetch(`${API}/api${path}`, {
    method,
    headers: { Accept: "application/json", "Content-Type": "application/json", ...authHeaders() },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await safeReadJson(r);
  if (data?._empty || data?._raw) {
    const err = new Error(`Request failed (HTTP ${r.status}: non-JSON body)`);
    err.status = r.status;
    throw err;
  }
  if (!r.ok) {
    const err = new Error(data.detail || `Request failed (${r.status})`);
    err.status = r.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const paymentsApi = {
  subscribe: (plan) => req("/payments/subscribe", { method: "POST", body: { plan, origin_url: window.location.origin } }),
  portal: () => req("/payments/portal", { method: "POST", body: { return_url: `${window.location.origin}/portal/billing` } }),
  checkoutStatus: (sessionId) => req(`/payments/checkout-status/${sessionId}`),
  mySubscription: () => req("/payments/subscription"),
};
